import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';
import { useBranding } from '../context/BrandingContext';

const linkGroups = [
  {
    title: 'Marketplace',
    links: [
      ['Find Shops', '/shops'],
      ['Material Calculator', '/calculator'],
      ['Wishlist', '/wishlist'],
      ['Cart', '/cart'],
      ['My Orders', '/orders'],
    ],
  },
  {
    title: 'Account',
    links: [
      ['Customer Sign Up', '/register'],
      ['Customer Login', '/login'],
      ['Customer Dashboard', '/dashboard'],
      ['Referral Program', '/#referral-program'],
    ],
  },
  {
    title: 'Business',
    links: [
      ['Sell on Material Stock', '/register/owner'],
      ['Owner Dashboard', '/owner/dashboard'],
      ['Manage Materials', '/owner/materials'],
    ],
  },
  {
    title: 'Support',
    links: [
      ['About Us', '/about'],
      ['Contact', '/contact'],
      ['Help Center', '/help'],
      ['Privacy Policy', '/privacy'],
      ['Terms & Conditions', '/terms'],
    ],
  },
];

export default function Footer() {
  const { branding } = useBranding();
  const appName = branding.appName || 'Material Stock';
  const brandLogoSrc = branding.darkLogoImage || branding.logoImage || '/material-stock-logo.jpg';

  return (
    <footer className="site-footer" style={{ background: 'var(--dark)', padding: '34px 16px 22px', marginTop: 36 }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: '1.3fr repeat(4, 1fr)', gap: 24, alignItems: 'start' }}>
          <div>
            <Link to="/" className={`footer-brand-lockup ${branding.darkLogoImage ? 'has-dark-logo' : ''}`} style={{ display: 'inline-flex', alignItems: 'center', textDecoration: 'none', marginBottom: 12 }}>
              <img src={brandLogoSrc} alt={appName} className="footer-brand-logo" />
            </Link>
            <p style={{ color: '#9CA3AF', fontSize: 13, lineHeight: 1.6, maxWidth: 280 }}>
              Construction materials from nearby verified shops with online advance payments, local delivery, and referral rewards.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 7, marginTop: 14, color: '#9CA3AF', fontSize: 12 }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: 7 }}><Phone size={13} /> +91 6300440316</span>
              <span style={{ display: 'flex', alignItems: 'center', gap: 7 }}><Mail size={13} /> {branding.supportEmail || 'support@materialstock.in'}</span>
              <span style={{ display: 'flex', alignItems: 'center', gap: 7 }}><MapPin size={13} /> Cyber Residency, Indira Nagar, Gachibowli, Hyderabad</span>
            </div>
          </div>

          {linkGroups.map(group => (
            <div key={group.title}>
              <h4 style={{ color: 'white', fontSize: 13, fontWeight: 800, marginBottom: 10 }}>{group.title}</h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {group.links.map(([label, to]) => (
                  <Link key={label} to={to} style={{ color: '#9CA3AF', fontSize: 13, textDecoration: 'none' }}>
                    {label}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', marginTop: 26, paddingTop: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
          <div style={{ color: '#6B7280', fontSize: 12 }}>&copy; 2026 {appName}. All rights reserved.</div>
          <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
            <Link to="/privacy" style={{ color: '#6B7280', fontSize: 12, textDecoration: 'none' }}>Privacy</Link>
            <Link to="/terms" style={{ color: '#6B7280', fontSize: 12, textDecoration: 'none' }}>Terms</Link>
            <Link to="/contact" style={{ color: '#6B7280', fontSize: 12, textDecoration: 'none' }}>Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
